import type { TaskData } from "@/components/TaskRow";
import { formatDueLabel } from "@/lib/dates";

export const DEFAULT_DISCUSS_PROMPT = "Помоги обдумать задачу из моего тудушника. Вот контекст.";

export function buildDiscussPrompt(
  task: TaskData,
  subtasks: TaskData[],
  parentTitle?: string,
  options?: { enabled?: boolean; custom?: string; link?: string },
): string {
  const { enabled = true, custom, link } = options ?? {};
  const parts: string[] = [];
  if (enabled) {
    const intro = custom?.trim() || DEFAULT_DISCUSS_PROMPT;
    parts.push(intro, "");
  }
  parts.push(`Задача: ${task.title}`);
  if (task.notes && task.notes.trim()) parts.push(`Заметки: ${task.notes.trim()}`);
  if (parentTitle) parts.push(`Родитель: ${parentTitle}`);
  if (task.listName) parts.push(`Список: ${task.listName}`);
  if (task.dueOn) parts.push(`Срок: ${formatDueLabel(task.dueOn).text}`);
  if (subtasks.length > 0) {
    const listing = subtasks.map((s, i) => `  ${i + 1}. ${s.title}`).join("\n");
    parts.push("Подзадачи:", listing);
  }
  if (link) parts.push(`Ссылка: ${link}`);
  return parts.join("\n");
}
